<div class="passwordContainer">
    <div class="inputWrapper">
        <input
            class="passwordInput"
            [id]="inputId"
            [name]="inputName"
            [type]="isPasswordVisible ? 'text' : 'password'"
            [formControl]="control"
            [placeholder]="placeholder"
            required
            [ngClass]="{ invalid: control.touched && control.invalid }"
            [appTrimSpaces]="true"
        />

        <button type="button" class="passwordVisibilityToggle" (click)="togglePasswordVisibility()">
            @if (!isPasswordVisible) {
                <div class="icon" [innerHTML]="passwordNotVisibleIcon"></div>
            }
            @if (isPasswordVisible) {
                <div class="icon" [innerHTML]="passwordVisibleIcon"></div>
            }
        </button>
    </div>

    @if (control.touched && control.errors) {
        <div class="error">
            @if (control.errors['required']) {
                <div>* Field required</div>
            }
            @if (minLength && control.errors['minlength']) {
                <div>* Field is shorter than the minimum length of {{ minLength }} characters</div>
            }
            @if (maxLength && control.errors['maxlength']) {
                <div>* *Field exceeds the maximum length of {{ maxLength }} characters</div>
            }
            @if (control.errors['passwordsMismatch']) {
                <div class="error">* New password and Repeat password do not match</div>
            }
        </div>
    }
</div>
